import {
    CrudAction,
    dispatchAfterFailureEpic,
    dispatchAfterFilterEpic,
    dispatchAfterSuccessEpic,
    executeCrudEpic,
    redirectAfterSuccessEpic,
    RouteType,
    Type
} from 'lib/crud'
import {NotificationsAction} from 'lib/notifications'
import {name} from 'lib/groupTeacher'
import {generateCrudPath} from 'lib/router'
import {State} from 'lib/store'
import {dao} from 'lib/users'
import {combineEpics} from 'redux-observable'

export const groupTeachersEpics = combineEpics(
    executeCrudEpic(name, Type.LIST)(dao.list),
    executeCrudEpic(name, Type.GET)(dao.get),
    executeCrudEpic(name, Type.UPDATE)(dao.update),

    redirectAfterSuccessEpic(name, Type.UPDATE, (action, state: State) => generateCrudPath(name, RouteType.LIST)),

    dispatchAfterSuccessEpic(name, Type.UPDATE, (action, state: State) => NotificationsAction.show({
        message: 'Dane nauczyciela zostały zaktualizowane',
        options: {variant: "success"}
    })),

    dispatchAfterFailureEpic(name, Type.UPDATE, (action, state: State) => NotificationsAction.show({
        message: 'Wystąpił błąd podczas aktualizacji nauczyciela',
        options: {variant: "error"}
    })),

    dispatchAfterFilterEpic(name, (action, state: State) => CrudAction.execute(name, Type.LIST, {
        orderName: state.teachers.crud.listOptions.sortDirection,
        page: state.teachers.crud.listOptions.page + 1,
        itemsPerPage: state.teachers.crud.listOptions.pageSize,
        ...state.teachers.crud.filters
    }))
)